import { Tag } from "antd";
import NoData from "assets/svgs/no_data/NoData";
import Loader from "modules/Loader";
import { getFormattedDate } from "modules/utilities/utility";
import AssignedDoctors from "pages/AssignedDoctors";
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";

function AssignedDoctorsTable({ tableData, isLoading }) {
  const header = [
    "Name",
    "Order Id",
    "Order Name",
    "New/Repeat",
    "Order Status",
    "Order Date",
    "Assigned To",
    "Owner",
    "AssignedDoctors",
  ];

  return (
    <div>
      <table className="d-flex flex-column mt-3  rounded table-hover">
        <thead className="d-flex text-gray border-black border rounded-top table-head">
          {header?.map((item) => (
            <th className="flex-1 fw-bold ps-2 border-end text-black mt-1 py-2">
              {item}
            </th>
          ))}
        </thead>
        <div
          style={{
            minHeight: "40vh",
            maxHeight: "60vh",
            overflowY: "scroll",
          }}
          className="scrollable-container"
        >
          {isLoading ? (
            <div className="position-absolute mt-5 start-50 top-50 translate-middle">
              <div>
                <Loader />
              </div>
            </div>
          ) : tableData?.length !== 0 ? (
            tableData?.map((item, index) => {
              return (
                <tr
                  id="table-row-value"
                  key={item?.key}
                  className={
                    item.checked
                      ? `flex-1 border border-top-0 table-row py-2  ${
                          index === tableData?.data?.length - 1 &&
                          `rounded-bottom`
                        } d-flex justify-content-between selected-table-row`
                      : `flex-1 border border-top-0  table-row ${
                          index === tableData?.data?.length - 1 &&
                          `rounded-bottom`
                        } d-flex justify-content-between`
                  }
                >
                  <td className="flex-1 ps-1 pe-1   border-end text-break text-primary cursor-pointer fw-bold">
                    <OverlayTrigger
                      overlay={
                        <Tooltip
                          style={{ position: "fixed" }}
                          id="overlay-trigger-example"
                        >
                          <div className="fs-1">Lead Details</div>
                        </Tooltip>
                      }
                    >
                      <Link
                        to={`/lead-details/${item?.case_id}`}
                        className="text-primary"
                      >
                        <div> {item?.name}</div>
                      </Link>
                    </OverlayTrigger>
                    <span className="">{item?.phone_Number}</span>
                  </td>
                  <td className="flex-1 ps-2 text-left border-end pt-2 text-wrap text-break text-black">
                    <div>{item?.orderDisplayId}</div>
                    <Tag className="uppercase" color="green">
                      {item.order_type?.replaceAll("_", " ")}
                    </Tag>
                  </td>
                  <OverlayTrigger
                    overlay={
                      <Tooltip
                        style={{ position: "fixed" }}
                        id="overlay-trigger-example"
                      >
                        <div className="fw-bold">{item?.orderName}</div>
                      </Tooltip>
                    }
                  >
                    <td className="flex-1 ps-2 text-left  cursor-pointer border-end pt-2 text-break text-wrap text-truncate">
                      <div className="text-truncate">
                        <span> {item?.orderName}</span>
                      </div>
                    </td>
                  </OverlayTrigger>

                  <td className="flex-1  ps-2  text-left border-end pt-2 text-wrap text-break text-primary">
                    {item?.count <= 1 ? (
                      <Tag color="gold" key={index}>
                        NEW
                      </Tag>
                    ) : (
                      <Tag color="green" key={index}>
                        <div className="text-break text-wrap">
                          REPEAT ORDER {item?.count}
                        </div>
                      </Tag>
                    )}
                  </td>
                  <td className="flex-1 py-3 ps-2 text-left border-end pt-2 text-break  text-wrap  text-primary">
                    <Tag key={item?.orderStatus} color="geekblue">
                      <div className="text-wrap">
                        {" "}
                        {item?.orderStatus && item?.orderStatus.toUpperCase()}
                      </div>
                    </Tag>
                  </td>
                  <td className="flex-1  py-3 ps-2 text-left border-end pt-2 text-wrap text-break text-black">
                    {getFormattedDate(item?.orderDate)}
                  </td>
                  <td className="flex-1  ps-2 py-3 text-left  border-end pt-2 text-wrap text-break text-black">
                    {item?.assignedTo}
                  </td>
                  <td className="flex-1  ps-1 text-left  border-end pt-2 text-wrap text-break text-black">
                    {item?.owner}
                  </td>
                  <td className="flex-1  ps-1 text-left  border-end pt-2 text-wrap text-break text-black">
                    {item?.assignedDoctor}
                  </td>
                </tr>
              );
            })
          ) : (
            <h3 className="text-center border p-3 rounded-bottom bg-white text-black">
              Data not found <NoData />
            </h3>
          )}
        </div>
      </table>
    </div>
  );
}

export default AssignedDoctorsTable;
